/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { containsSpecialCharacter, hasUpperLetter } from '../../rejestracja/Rejestracja';
import s from '../Login.css';

class ResetPassword extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      passOne: '',
      passTwo: '',
      passOneValid: false,
      passwordsMatch: false,
      errorMessage: null,
    };
  }
  handleClick = () => {}

  executeOnSubmit = e => {
    e.preventDefault();
    const passOne = this.passTwoValidator();
    const passTwo = this.passTwoValidator();
    if (passOne === false || passTwo === false) return;
  }

  handlePassOne = e => {
    this.setState({ passOne: e.target.value });
  }
  handlePassTwo = e => {
    this.setState({ passTwo: e.target.value });
  }
  passOneValidator = e => {
    if (e.target.value.length <= 6) {
      this.setState({ passOneValid: false, errorMessage: 'Hasło powinno zawierać przynajmniej 6 znaków' });
      return false;
    } else {
      // this.setState({ passOneValid: true, errorMessage: null });
    }
    const upperLetters = hasUpperLetter(e.target.value);
    if (upperLetters !== null) {
      this.setState({ passOneValid: false, errorMessage: upperLetters });
      return false;
    } else {
      this.setState({ passOneValid: true, errorMessage: null });
    }
    const specialChars = containsSpecialCharacter(e.target.value);
    if (specialChars !== null) {
      this.setState({ passOneValid: false, errorMessage: specialChars });
      return false;
    } else {
      this.setState({ passOneValid: true, errorMessage: null });
    }
  }
  passTwoValidator = () => {
    if (this.state.passOne === this.state.passTwo) {
      this.setState({ passwordsMatch: true });
    } else {
      this.setState({ passwordsMatch: false, errorMessage: 'Hasła się nie zgadzają' });
      return false;
    }
  }

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1>{this.props.title}</h1>

          <form method="post" onSubmit={this.executeOnSubmit}>
            <div className={s.formGroup}>
              <label className={s.label} htmlFor="passOne">
                Wpisz nowe hasło:
              </label>
              <input
                className={s.input}
                id="passOne"
                type="password"
                name="passwordOne"
                autoFocus
                value={this.state.passOne}
                placeholder="Wpisz nowe hasło"
                onBlur={(e) => this.passOneValidator(e)}
                onChange={e => this.handlePassOne(e)}
              />
              <label className={s.label} htmlFor="passTwo">
                Wpisz powtórnie hasło:
              </label>
              <input
                className={s.input}
                id="passTwo"
                type="password"
                name="passwordTwo"
                value={this.state.passTwo}
                placeholder="Powtórz hasło"
                onBlur={this.passTwoValidator}
                onChange={e => this.handlePassTwo(e)}
              />
              <button className={s.button} onClick={this.handleClick} type="submit">
                Zatwierdź
              </button>
            </div>
          </form>
          {
            this.state.errorMessage !== null ?
              <div className={s.errorMsg}>{this.state.errorMessage}</div> :
              null
          }
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ResetPassword);



// WEBPACK FOOTER //
// src/routes/login/confirmPassword/ConfirmPassword.js